<template>
    <basic-card
        :image="card.cover_image ? card.cover_image.url : ''"
        :title="card.title"
        :label="card.miu_type ? trans(`streams.dashboard.${card.miu_type.name}`) : ''"
        :description="card.time_to_complete"
        :class="classesCard"
    >
        <b-button
            v-if="!card.completed"
            variant="secondary"
            @click="$emit('onCta', card)"
            size="sm"
            class="mt-3"
        >
            {{trans('onboarding.start')}}
        </b-button>
        <b-button
            v-else
            variant="success"
            pill
            @click="$emit('onCta', card)"
            size="sm"
            class="pr-3 mt-3"
        >
            <b-icon-check v-if="card.completed" />
            {{trans('onboarding.completed')}}
        </b-button>
    </basic-card>
</template>

<script>
    import BasicCard from "../cards/BasicCard"

    export default {
        name: "OnBoardingCard",
        components: {
            BasicCard
        },
        props: {
            card: Object,
            classesCard: String
        }
    }
</script>